import React from 'react'
import { StarChartItemDeletePresentationProps } from '../../types/types'
import { StarChartCloseIcon, StarChartDialogStyle, StarChartFormCol, StarChartItemDeleteDesc, StarChartItemDeleteTitle } from './StarChartItemDeletePresentation.style'
import { DialogContent } from '@mui/material'
import { CancelButton, CancelButtonText, DeleteButton, DeleteButtonText } from '../../../../assets/style/General.style'

import { images } from '../../../../constants'


const StarChartItemDeletePresentation: React.FC<StarChartItemDeletePresentationProps> = ({starChartDelete , closeDeletePopup , starChartName}) => {

  return (
    <StarChartDialogStyle
    open={starChartDelete}
    onClose={closeDeletePopup}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogContent sx={{ width: '500px', padding: '24px' }}>

        <StarChartCloseIcon
            onClick={closeDeletePopup}
            src={images.closeIconSimple}
                            
        />
        <StarChartFormCol alignment="flex-start" Direction={'column'}>
                <StarChartItemDeleteTitle>Detele StarChart</StarChartItemDeleteTitle>
                <StarChartItemDeleteDesc style={{paddingBottom:15}}>Are you sure you want to delete  {starChartName} StarChart?</StarChartItemDeleteDesc>
                <StarChartItemDeleteDesc>Students and Organizations have this StarChart assigned. If you delete it they will lose all permissions on it and won’t see the experiences related.</StarChartItemDeleteDesc>
        </StarChartFormCol>
        <StarChartFormCol alignment="flex-end" Direction={'row'} style={{width:"100%", paddingTop:15}}>
                  
                        <CancelButton
                          style={{ marginLeft: '15px', width: '60px' }}
                          onClick={closeDeletePopup}
                        >
                          <CancelButtonText >Cancel</CancelButtonText>
            
                          
                        </CancelButton>
            
            
            
                        <DeleteButton
                          style={{ marginLeft: '9px' }}
                          onClick={()=>{}}
                        >
                          <DeleteButtonText>Delete</DeleteButtonText>
            
                          
                        </DeleteButton>
        </StarChartFormCol>


      </DialogContent>
    </StarChartDialogStyle>


  )
}

export default StarChartItemDeletePresentation